module.exports = __webpack_public_path__ + "img/True Color.502fb8a4.svg";